"use client";

import {
  type Command,
  type CommandIdentifierHandler,
  GenericCommandItem,
  useCommandPaletteRegisterHandler,
} from "@pharaday/command-palette";
import { ArrowRightIcon } from "@pharaday/lighthouse";
import { useRouter } from "next/navigation";
import { type PropsWithChildren } from "react";

import useFilteredAppListByFeatureFlag from "../../hooks/useFilteredAppListByFeatureFlag";
import { getAppCommandIdentifier } from "../../utils/get-app-command-identifier";

export type CommandHandlerProviderProps = PropsWithChildren;

const NavigateCommandItem = (props: Command) => <GenericCommandItem Icon={ArrowRightIcon} {...props} />;

const NavigationCommandProvider = ({ children }: CommandHandlerProviderProps) => {
  const { data } = useFilteredAppListByFeatureFlag();
  const router = useRouter();

  useCommandPaletteRegisterHandler(
    ...(data || [])
      .filter(app => app.urlRoot && getAppCommandIdentifier(app.type))
      .map<CommandIdentifierHandler>(app => ({
        identifier: getAppCommandIdentifier(app.type)!,
        commandItem: NavigateCommandItem,
        commandFn: () => router.push(app.urlRoot!),
      }))
  );

  return children;
};

export default NavigationCommandProvider;
